import React, { useState } from 'react';
import { Redirect } from 'react-router-dom'
import AuthService from '../../../services/auth.service'

const IsAuthenticatedWrapper = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(undefined);

    AuthService().isAuthenticated()
        .then((data) => {
            setIsAuthenticated(data);
        })
        .catch(err => {
            AuthService().logout();
            setIsAuthenticated(false);
        });

    return (isAuthenticated ? children : (isAuthenticated === false ? <Redirect to="/login" /> : 'loading'))
}

export default IsAuthenticatedWrapper;